import { render, staticRenderFns } from "./TableCustomerList.vue?vue&type=template&id=dab0ec60&scoped=true"
import script from "./TableCustomerList.vue?vue&type=script&lang=js"
export * from "./TableCustomerList.vue?vue&type=script&lang=js"
import style0 from "./TableCustomerList.vue?vue&type=style&index=0&id=dab0ec60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab0ec60",
  null
  
)

export default component.exports